import { cloned } from '@/helpers'

const _EMPTY = {
  id: null,
  address_info: "",
  billing_info: {},
  country: "AR",
  country_descr: "Argentina",
  extras: {},
  field: "",
  logo: "",
  name: "Testing Tremé",
  state_descr: "",
  status: "",
  status_descr: "",
  www: "",
  roles: [],
}

export const Account = {

  empty () {
    return cloned(_EMPTY)
  },

  import (o) {
    return cloned(o)
  },

  export (o) {
    return cloned(o)
  },

  get () {
    
    if (!Idb.ready()) return null

    // var o = JSON.parse(localStorage.getItem('account'))
    var o = Idb.get('account').then((result) => {
      console.log("Account.js idb then result", result)
      return result.value
    })
    console.log("Account.js get returns", o)
    return o ;
  },

  async save (o) {
    // first save logo in Idb, and then remove it from account
    // because it may be too big for localStorage and memory
    // Idb.put('account-logo', o.logo).then(() => {
    //   console.log("Account.js: save(): Logo saved ok.")
    // }) ;
    // o.logo = 'Idb::account-logo';

    
    // localStorage.setItem('account', JSON.stringify(o))
    console.log("Account.js save() initiate")
    // update Appl for the older code
    Appl.profile.info['account'] = o
    
    if (!Idb.ready()) return null
    
    await Idb.put('account', o).then(() => {
      console.log("Account.js: save(). Account saved", o)
    })
  }
}
